module.exports = __webpack_public_path__ + "media/application/images/ui/badge-peoples-choice-with-text-small-d27470509f8feeb7d42d80b3df87f6db.png";